// import React, { useEffect, useState } from 'react';
// import { Get_Api } from '../Api_Url';

// function AllBanner() {
//     const [allBanners, setAllBanners] = useState([
//         {
//             "_id": "67cae99342e57b5ae85f8aa8",
//             "Image": "https://res.cloudinary.com/dwewlzhdz/image/upload/v1741351315/AvailableFor/Image/trohrsnby0ffuwtuffhy.png",
//             "Url": "https://www.expleradmc.com/",
//             "createdAt": "2025-03-07T12:41:55.926Z",
//             "updatedAt": "2025-03-07T12:41:55.926Z",
//             "__v": 0
//         }
//     ]);
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [isUploading, setIsUploading] = useState(false);

//     const getBanner = async () => {
//         try {
//             setIsUploading(true);
//             const response = await Get_Api('api/admin/GetAllBanner');
//             setAllBanners(response?.data || []);
//             setIsUploading(false);
//         } catch (error) {
//             setIsUploading(false);
//             console.error(error);
//         }
//     };

//     useEffect(() => {
//         getBanner();
//     }, []);

//     useEffect(() => {
//         const interval = setInterval(() => {
//             setCurrentIndex((prevIndex) => (prevIndex + 1) % allBanners.length);
//         }, 5000);

//         return () => clearInterval(interval);
//     }, [allBanners]);

//     const handleDotClick = (index) => {
//         setCurrentIndex(index);
//     };
//     const openLinkInNewTab = (url) => {
//         if (url && url.trim() !== "") {
//             window.open(url, "_blank");
//         } else {
//             console.warn("Invalid URL: Cannot open a blank or null link.");
//         }
//     };

//     return (
//         <div className='home-banner-container'>
//             <div className='home-banner' style={{
//                 backgroundImage: `url(${allBanners[currentIndex]?.Image || ''})`,
//                 backgroundSize: 'cover',
//                 backgroundPosition: 'center',
//             }}>
//                 <div className='home-banner-left'>
//                     <h2>Iceland's legendary<br /> Golden Circle</h2>
//                     <h6>Enjoy a full-day bus tour of Iceland's legendary Golden Circle.<br />
//                         Soak in the warm thermal waters of the Secret Lagoon.</h6>
//                     <button onClick={() => { openLinkInNewTab(allBanners[currentIndex]?.Url) }}>View Tours</button>
//                 </div>
//             </div>
//             <div className='dots-container'>
//                 {allBanners.map((_, index) => (
//                     <span
//                         key={index}
//                         className={`dot ${index === currentIndex ? 'active' : ''}`}
//                         onClick={() => handleDotClick(index)}
//                     ></span>
//                 ))}
//             </div>
//         </div>
//     );
// }

// export default AllBanner;

import React, { useEffect, useState } from 'react';
import { Get_Api } from '../Api_Url';

function AllBanner() {
    const [allBanners, setAllBanners] = useState([
        {
            "_id": "67cae99342e57b5ae85f8aa8",
            "Image": "https://res.cloudinary.com/dwewlzhdz/image/upload/v1741351315/AvailableFor/Image/trohrsnby0ffuwtuffhy.png",
            "Url": "https://www.expleradmc.com/",
            "Heading": "Iceland's legendary Golden Circle",
            "Text": "Enjoy a full-day bus tour of Iceland's legendary Golden Circle. Soak in the warm thermal waters of the Secret Lagoon.",
            "createdAt": "2025-03-07T12:41:55.926Z",
            "updatedAt": "2025-03-07T12:41:55.926Z",
            "__v": 0
        }
    ]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isUploading, setIsUploading] = useState(false);

    const getBanner = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api('api/admin/GetAllBanner');
            setAllBanners(response?.data || []);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error(error);
        }
    };

    useEffect(() => {
        getBanner();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % allBanners.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [allBanners]);

    const handleDotClick = (index) => {
        setCurrentIndex(index);
    };

    const openLinkInNewTab = (url) => {
        if (url && url.trim() !== "") {
            window.open(url, "_blank");
        } else {
            console.warn("Invalid URL: Cannot open a blank or null link.");
        }
    };

    return (
        <div className='home-banner-container'>
            <div className='home-banner' style={{
                backgroundImage: `url(${allBanners[currentIndex]?.Image || ''})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}>
                <div className='home-banner-left'>
                    <h2>{allBanners[currentIndex]?.Heading || "Iceland's legendary Golden Circle"}</h2>
                    <h6>{allBanners[currentIndex]?.Text || "Enjoy a full-day bus tour of Iceland's legendary Golden Circle.Soak in the warm thermal waters of the Secret Lagoon."}</h6>
                    <button onClick={() => openLinkInNewTab(allBanners[currentIndex]?.Url)}>View Tours</button>
                </div>
            </div>
            <div className='dots-container'>
                {allBanners.map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => handleDotClick(index)}
                    ></span>
                ))}
            </div>
        </div>
    );
}

export default AllBanner;

